<template>
  <v-app>
    <div class="login-content color-change">
      <div class="login-logo animated fadeInDown slow">
        <!-- <img src="img/last_logo-tomolab.png" class="logo" /> -->
        <img src="img/last_logo-tomolab.png" class="logo" />
        <!-- src="img/last_logo-tomolab.png" -->
      </div>
      <div style="display:flex; width:100%; justify-content:center;">
        <label for="" class="title">
          VALIDACION DE RESULTADOS
        </label>
      </div>
      <div class="container-main">
        <div class="nameOpcion">
          <div style="display:flex; align-items: center;">
            <v-icon class="nameOpcion" style="color: green;"
              >fa-solid fa-check</v-icon
            >
            <label class="nameOpcion" style="color: green; margin-left: 10px;"
              >N° DE CONSTANCIA :
            </label>
            <label
              class="nameOpcion"
              style="color: black; font-weight: bold; font-size:18px; margin-left: 10px;"
              >{{ form.office_abreviado }}</label
            >
          </div>
        </div>
        <div class="nameOpcion">
          <div style="display:flex; align-items: center;">
            <v-icon class="nameOpcion" style="color: green;"
              >fa-solid fa-check</v-icon
            >
            <label
              class="nameOpcion"
              for=""
              style="color: green;  margin-left: 10px;"
              >DOCUMENTO PACIENTE :
            </label>
            <label
              class="nameOpcion"
              for=""
              style="color: black; font-weight: bold; font-size:18px;  margin-left: 10px;"
              >{{ form.customer_document }}</label
            >
          </div>
        </div>
        <div class="nameOpcion">
          <div style="display:flex; align-items: center;">
            <v-icon class="nameOpcion" style="color: green;"
              >fa-solid fa-check</v-icon
            >
            <label
              class="nameOpcion"
              for=""
              style="color: green;  margin-left: 10px;"
              >PACIENTE :
            </label>
            <label
              class="nameOpcion"
              for=""
              style="color: black; font-weight: bold; font-size:18px;  margin-left: 10px;"
              >{{ form.customer_full_name }}</label
            >
          </div>
        </div>
        <div class="nameOpcion">
          <div style="display:flex; align-items: center;">
            <v-icon class="nameOpcion" style="color: green;"
              >fa-solid fa-check</v-icon
            >
            <div
              style="margin-left: 10px;height: 2rem;display: flex; width: 5rem;"
            >
              <label class="nameOpcion" for="" style="color: green;  "
                >ANÁLISIS :
              </label>
            </div>
            <div style="margin-left: 10px;">
              <label
                class="nameOpcion"
                for=""
                style="color: black; font-weight: bold; font-size:18px;  "
                >{{ form.analysis_all }}</label
              >
            </div>
          </div>
        </div>
        <div class="nameOpcion">
          <div style="display:flex; align-items: center;">
            <v-icon class="nameOpcion" style="color: green;"
              >fa-solid fa-check</v-icon
            >
            <label
              class="nameOpcion"
              for=""
              style="color: green;  margin-left: 10px;"
              >FECHA DE T.M :
            </label>
            <label
              class="nameOpcion"
              for=""
              style="color: black; font-weight: bold; font-size:18px;  margin-left: 10px;"
              >{{ form.date_hora_muestra }}</label
            >
          </div>
        </div>
        <div class="nameOpcion">
          <div style="display:flex; align-items: center;">
            <v-icon class="nameOpcion" style="color: green;"
              >fa-solid fa-check</v-icon
            >
            <label
              class="nameOpcion"
              for=""
              style="color: green;  margin-left: 10px;"
              >FECHA DE EMISION DEL INFORME :
            </label>
            <label
              class="nameOpcion"
              for=""
              style="color: black; font-weight: bold; font-size:18px;  margin-left: 10px;"
              >{{ form.date_creado }}</label
            >
          </div>
        </div>
      </div>
      <div class="container-footer">
        <label for="" class="title-footer" style="color:black;">
          Este mensaje contiene información CONFIDENCIAL. En caso no corresponda
          con el informe recibido, agradeceremos notificarlo a nuestra área de
          atención y comunicarse al 913 338 434
        </label>
      </div>
    </div>
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Valiant from "../../apis/Validate";
import Axios from "axios";
import Encrypt from "../../helpers/Encrypt/Encrypt";

export default {
  name: "ValidatePdf",
  data() {
    return {
      showLogin: true,
      showCompanies: false,
      companies: [],
      value_company: null,
      disabled_company: false,
      sedes: [],
      value_sede: null,
      disabled_sede: false,
      offices: [],
      value_office: null,
      show_message_login: false,
      validateQuery: false,
      venta: {},
      procesamiento: {},
      form: {
        analysis_all: "",
        customer_document: "",
        customer_full_name: "",
        date_creado: "",
        date_hora_muestra: "",
        hour_toma_muestra: "",
        office_abreviado: "",
        venta_id: null,
      },
    };
  },
  computed: {
    ...mapState("authentication", [
      "current_employee",
      "token",
      "select_office",
      "user_companies",
      "user_sedes",
      "user_offices",
    ]),
  },
  methods: {
    ...mapActions("authentication", ["set_office_login"]),

    async getInfo(id_sale, id_procesamiento, analisis) {
      const linkUrl = `https://resultados.tomolab.com.pe:444/api/validate`;
      // const linkUrl = `http://localhost:8000/api/validate`;
      const response = await Axios.get(`${linkUrl}`, {
        headers: { "Access-Control-Allow-Origin": "*" },
        params: { id_sale, id_procesamiento },
      });
      // const response = await Valiant.get_all({id_sale, id_procesamiento})
      if (response.status == 200) {
        // ? respuesta valida
        // this.venta = response.data.venta;
        // this.procesamiento = response.data.procesamiento;

        this.parseData(response.data, analisis);
      } else {
        // ? no hay respuesta valida
      }
    },
    parseData(data, analisis) {
      // console.log(analisis);
      // console.log(data.analysis_all);
      const dateHoraMuestraArray = data.date_hora_muestra.split(" ");
      const dateCreadoArray = data.date_creado.split(" ");

      this.form.analysis_all = analisis;
      // this.form.analysis_all = data.analysis_all;
      this.form.customer_document = data.customer_document;
      this.form.customer_full_name = data.customer_full_name;
      this.form.date_creado = dateCreadoArray[0];
      this.form.date_hora_muestra = dateHoraMuestraArray[0];
      this.form.hour_toma_muestra = data.hour_toma_muestra;
      this.form.office_abreviado =
        data.office_abreviado + "-00" + data.order_servicio;
      this.form.venta_id = data.venta_id;

      // const customer = venta.customer;
      // this.form.constancia = "S-00" + venta.id.toString();
      // this.form.date_procesamiento = this.formatDate(
      //   new Date(procesamiento.created_at)
      // );
      // const [name1, name2] = customer.name.split(" ");
      // const [apellido1, apellido2] = customer.surname.split(" ");
      // // this.form.paciente = name1.charAt(0) + "." + name2.charAt(0) + "." + apellido1.charAt(0) + "." + apellido2.charAt(0)+'..'
      // this.form.paciente = customer.name + " " + customer.surname;
    },
    formatDate(date) {
      let formatted_date =
        date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
      return formatted_date;
    },
  },
  created() {
    const id_sale = this.$route.query.id_sale;
    const id_procesamiento = this.$route.query.id_procesamiento;
    let analisis = this.$route.query.analisis;
    if (analisis.length > 0) {
      analisis = analisis.replaceAll(",", ", ");
      analisis = analisis + ".";
    }
    if ((id_sale, id_procesamiento)) {
      // ! enviar la consulta al backend
      this.validateQuery = true;
      this.getInfo(id_sale, id_procesamiento, analisis);
    }
  },
};
</script>

<style scoped>
/* html{
	height: 100%;
	background-color: #f4f6f8 !important;
}

body{
	margin: 0px !important;
	height: 100%;	
	color: #ffffff;	
    
} */

@media (min-width: 0px) and (max-width: 350px) {
  .logo {
    display: flex !important;
    width: 400px !important;
    height: 120px !important;
  }
  .title {
    display: flex !important;
    color: green !important;
    font-weight: bold !important;
    font-size: 12px !important;
  }
  .nameOpcion {
    padding: 5px 0 !important;
    font-size: 9px !important;
  }
  .title-footer {
    font-size: 9px !important;
  }
  .container-main {
    width: 90%;
    padding: 20px 0 15px 0;
  }
  .container-footer {
    width: 90%;
    background-color: #8ae0db;
    padding: 15px;
    border-radius: 5px;
    text-align: center;
  }
}

@media (min-width: 350px) and (max-width: 850px) {
  .logo {
    display: flex !important;
    width: 220px !important;
    height: 90px !important;
  }
  .title {
    display: flex !important;
    color: green !important;
    font-weight: bold !important;
    font-size: 15px !important;
  }
  .nameOpcion {
    padding: 5px 0 !important;
    font-size: 12px !important;
  }
  .title-footer {
    font-size: 12px !important;
  }
  .container-main {
    width: 70% !important;
    padding: 20px 0 15px 0 !important;
  }
  .container-footer {
    width: 70% !important;
    background-color: #8ae0db !important;
    padding: 15px !important;
    border-radius: 5px !important;
    text-align: center !important;
  }
}

@media (min-width: 850px) and (max-width: 1250px) {
  .logo {
    display: flex !important;
    width: 280px !important;
    height: 110px !important;
  }
  .title {
    display: flex !important;
    color: green !important;
    font-weight: bold !important;
    font-size: 17px !important;
  }
  .nameOpcion {
    padding: 5px 0 !important;
    font-size: 13px !important;
  }
  .title-footer {
    font-size: 13px !important;
  }
  .container-main {
    width: 60% !important;
    padding: 20px 0 15px 0 !important;
  }
  .container-footer {
    width: 60% !important;
    background-color: #8ae0db !important;
    padding: 15px !important;
    border-radius: 5px !important;
    text-align: center !important;
  }
}

@media (min-width: 1250px) and (max-width: 3000px) {
  .logo {
    display: flex !important;
    width: 350px !important;
    height: 120px !important;
  }
  .title {
    display: flex !important;
    color: green !important;
    font-weight: bold !important;
    font-size: 19px !important;
  }
  .nameOpcion {
    padding: 5px 0 !important;
    font-size: 15px !important;
  }
  .title-footer {
    font-size: 15px !important;
  }
  .container-main {
    width: 50% !important;
    padding: 20px 0 15px 0 !important;
  }
  .container-footer {
    width: 50% !important;
    background-color: #8ae0db !important;
    padding: 15px !important;
    border-radius: 5px !important;
    text-align: center !important;
  }
}

.login-content {
  background-color: #e3e3e3 !important;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #ffffff;
  font-family: "Baloo Bhaina 2" !important;
  /* font-size: 16px !important; */
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #ffffff;
  font-family: "Baloo Bhaina 2" !important;
}

.login-logo {
  margin-bottom: 15px;
}

.login-title {
  display: block;
  margin-bottom: 15px;
}

.login-subtitle {
  margin-bottom: 15px;
}

.login-form {
  display: block !important;
  height: 250px !important;
}

.login-textfield {
  height: 40px !important;
  border-radius: 14px !important;
  border: 1px solid #244167 !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
  display: block !important;
  margin-top: 20px !important;
  margin-bottom: 4px !important;
  width: 270px !important;
  color: #ffffff !important;
  background-color: #244167 !important;
  outline: none !important;
  font-family: "Baloo Bhaina 2" !important;
  font-size: 0.9rem !important;
}

.login-button {
  height: 45px;
  border-radius: 14px;
  border: 1px solid #26beba;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 12px;
  padding-right: 12px;
  display: block;
  margin-top: 10px;
  margin-bottom: 4px;
  width: 100%;
  color: #03164e;
  background-color: #26beba;
  cursor: pointer;
  font-family: "Baloo Bhaina 2";
  font-size: 1rem;
  font-weight: bold;
  outline: none;
}

.login-title-text {
  font-size: 2.3rem !important;
  font-weight: 500 !important;
}

::-webkit-input-placeholder {
  /* Edge */
  color: #ffffff !important;
  font-family: "Baloo Bhaina 2" !important;
  font-size: 0.9rem !important;
}

:-ms-input-placeholder {
  /* Internet Explorer */
  color: #ffffff !important;
  font-family: "Baloo Bhaina 2" !important;
  font-size: 0.9rem !important;
}

::placeholder {
  color: #ffffff !important;
  font-family: "Baloo Bhaina 2" !important;
  font-size: 0.9rem !important;
}

.v-input__slot {
  background-color: #244167 !important;
}
</style>
